import { Box, Button } from "@drone-js/core";
import { useStaticDataAtomValue } from "apps/oneOnboarding/staticDataAtom";
import { useParams } from "router";
import { useBatchCompletePageViewModel } from "./useBatchCompletePageViewModel";

export const BatchCallToAction = () => {
    const {
        cmsData: {
            complete: { addNewListingText, manageListingText },
        },
    } = useStaticDataAtomValue();
    const { lang } = useParams("/:lang/list-my-property/onboard/batch/complete");
    const { manageListingUrl } = useBatchCompletePageViewModel();

    return (
        <Box
            display="flex"
            justifyContent="end"
            flexDirection="column-reverse"
            qM={{ flexDirection: "row" }}
            data-element-name="batch-call-to-action"
            data-testid="batch-call-to-action"
        >
            <Box me="0" mt="16" qM={{ me: "16", mt: "0" }}>
                <Button
                    variant="label"
                    size="l"
                    hierarchy="secondary"
                    label={addNewListingText}
                    data-element-name="add-new-listing"
                    data-testid="batch-add-new-listing-button"
                    href={`/${lang}/list-my-property/get-started`}
                />
            </Box>
            <Button
                variant="label"
                size="l"
                hierarchy="primary"
                data-element-name="manage-listing"
                data-testid="batch-manage-listing-button"
                label={manageListingText}
                href={manageListingUrl}
            />
        </Box>
    );
};
